export const NO_SOURCES_FOUND = 'NO_SOURCES_FOUND';
export const NO_REPOS_FOUND = 'NO_REPOS_FOUND';
export const NO_BRANCHES_FOUND = 'NO_BRANCHES_FOUND';
// This is the exact error message surfaced by the cd4pe client
export const NO_TAGS_FOUND = 'NO_TAGS_FOUND';
